var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "warp",
      staticStyle: {
        padding: "5px 15px",
        height: "calc(100vh - 80px)",
        overflow: "auto",
      },
    },
    [
      _c("div", [
        _c("div", { staticClass: "flx-justify-between01" }, [
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("vehicle.matter"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("operationTips.confirmLost"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.StolenOrRobbed"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.Damage"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("vehicle.complaintHandling"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.SocialMediaUpgradeComplaint"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.PODIrregular"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(
              _vm._s(_vm.$t("compensationManagement.TimeoutNotClosedLoop"))
            ),
          ]),
        ]),
        _c("div", { staticClass: "flx-justify-between01" }, [
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("collectionCenter.ballot"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.confirmedLost)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.stolenOrRobbed)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.damaged)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.complaintWorkOrderCount)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.platformComplaints)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.podIrregularities)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.overtimeNotClosed)),
          ]),
        ]),
        _c("div", { staticClass: "flx-justify-between01" }, [
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.EstimatedPenaltyAmount"))),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.confirmedLostAmount)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.stolenOrRobbedAmount)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.damagedAmount)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.complaintWorkOrderAmount)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.platformComplaintsAmount)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.podIrregularitiesAmount)),
          ]),
          _c("div", { staticStyle: { flex: "1" } }, [
            _vm._v(_vm._s(_vm.statisticData.overtimeNotClosedAmount)),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticStyle: { margin: "15px 0" } },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.exportToExcel },
            },
            [_vm._v(_vm._s(_vm.$t("newOrder.export")) + " ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": { background: "#f2f2f2", color: "black" },
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.serial"),
              align: "center",
              type: "index",
              width: "60",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.waybillNumber"),
              align: "center",
              prop: "waybillNumber",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.ScanNumber"),
              align: "center",
              prop: "scanOrderNumber",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.DefiniteType"),
              align: "center",
              prop: "responsibilityTypeStr",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.DefiniteTime"),
              align: "center",
              prop: "responsibilityTime",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("fixDutyFine.ResponsibleBranch"),
              align: "center",
              prop: "siteName",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("vehicle.cargoValue"),
              align: "center",
              prop: "cargoValueStr",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("collectionCenter.freight"),
              align: "center",
              prop: "freightStr",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("vehicle.fine"),
              align: "center",
              prop: "fineStr",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("vehicle.penaltyAmount"),
              align: "center",
              prop: "penaltyAmountStr",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { "text-align": "right" } },
        [
          _c("el-pagination", {
            staticStyle: { margin: "15px 0" },
            attrs: {
              "current-page": _vm.searchForm.pageNumber,
              "page-size": _vm.searchForm.pageSize,
              "page-sizes": [10, 20, 50, 100],
              total: _vm.total,
              background: "",
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.searchForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.searchForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.searchForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.searchForm, "pageSize", $event)
              },
              "current-change": _vm.getSearch,
              "size-change": _vm.getSearch,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }